export const yr2021 = {
    zelfstandigenaftrek: 6670,
    startersaftrek: 2123,
    mkbVrijstelling: 14,
    zvwBijdrage: { pct: 5.75, limit: 58311 },
    arbeidskorting: [
        { low: 0, high: 10108, pct: 4.581, addition: 0 },
        { low: 10108, high: 21835, pct: 28.771, addition: 463 },
        { low: 21835, high: 35652, pct: 2.663, addition: 3837 },
        { low: 35652, high: 105736, pct: -6, addition: 4205 },
        { low: 105736, high: 999999999, pct: 0, addition: 0 }
    ],
    belasting: [
        { low: 0, high: 68507, pct: 37.10, addition: 0 },
        { low: 68507, high: 999999999, pct: 49.50, addition: 25416 },
    ],
    heffingskorting: [
        { low: 0, high: 21043, pct: 0, addition: 2837 },
        { low: 21043, high: 68507, pct: -5.977, addition: 2837 },
        { low: 68507, high: 999999999, pct: 0, addition: 0 },
    ],
    inkomenhoogsteschaal: 68507,
    tarrifaanpassing: 0.0650,
}